import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["focus"];

var _de;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import F, { createContext as D, useCallback as m, useContext as _, useEffect as x, useMemo as O, useReducer as le, useRef as M, useState as pe } from "react";
import { match as j } from "../../utils/match.js";
import { forwardRefWithAs as G, render as H, Features as K } from "../../utils/render.js";
import { useSyncRefs as B } from "../../hooks/use-sync-refs.js";
import { useId as $ } from "../../hooks/use-id.js";
import { Keys as A } from "../keyboard.js";
import { isDisabledReactIssue7711 as ee } from "../../utils/bugs.js";
import { getFocusableElements as w, Focus as I, focusIn as L, FocusResult as Y, isFocusableElement as ae, FocusableMode as ue } from "../../utils/focus-management.js";
import { OpenClosedProvider as ie, State as U, useOpenClosed as te } from "../../internal/open-closed.js";
import { useResolveButtonType as se } from "../../hooks/use-resolve-button-type.js";
import { useOutsideClick as fe } from "../../hooks/use-outside-click.js";
import { getOwnerDocument as Pe } from "../../utils/owner.js";
import { useOwnerDocument as q } from "../../hooks/use-owner.js";
import { useEventListener as W } from "../../hooks/use-event-listener.js";

var ve = function (f) {
  return f[f.Open = 0] = "Open", f[f.Closed = 1] = "Closed", f;
}(ve || {}),
    ce = function (l) {
  return l[l.TogglePopover = 0] = "TogglePopover", l[l.ClosePopover = 1] = "ClosePopover", l[l.SetButton = 2] = "SetButton", l[l.SetButtonId = 3] = "SetButtonId", l[l.SetPanel = 4] = "SetPanel", l[l.SetPanelId = 5] = "SetPanelId", l;
}(ce || {});

var de = (_de = {}, _defineProperty(_de, 0, function _(a) {
  var _j;

  return _objectSpread(_objectSpread({}, a), {}, {
    popoverState: j(a.popoverState, (_j = {}, _defineProperty(_j, 0, 1), _defineProperty(_j, 1, 0), _j))
  });
}), _defineProperty(_de, 1, function _(a) {
  return a.popoverState === 1 ? a : _objectSpread(_objectSpread({}, a), {}, {
    popoverState: 1
  });
}), _defineProperty(_de, 2, function _(a, o) {
  return a.button === o.button ? a : _objectSpread(_objectSpread({}, a), {}, {
    button: o.button
  });
}), _defineProperty(_de, 3, function _(a, o) {
  return a.buttonId === o.buttonId ? a : _objectSpread(_objectSpread({}, a), {}, {
    buttonId: o.buttonId
  });
}), _defineProperty(_de, 4, function _(a, o) {
  return a.panel === o.panel ? a : _objectSpread(_objectSpread({}, a), {}, {
    panel: o.panel
  });
}), _defineProperty(_de, 5, function _(a, o) {
  return a.panelId === o.panelId ? a : _objectSpread(_objectSpread({}, a), {}, {
    panelId: o.panelId
  });
}), _de),
    z = D(null);
z.displayName = "PopoverContext";

function N(a) {
  var o = _(z);

  if (o === null) {
    var f = new Error("<".concat(a, " /> is missing a parent <Popover /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(f, N), f;
  }

  return o;
}

var J = D(null);
J.displayName = "PopoverAPIContext";

function oe(a) {
  var o = _(J);

  if (o === null) {
    var f = new Error("<".concat(a, " /> is missing a parent <Popover /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(f, oe), f;
  }

  return o;
}

var Q = D(null);
Q.displayName = "PopoverGroupContext";

function re() {
  return _(Q);
}

var X = D(null);
X.displayName = "PopoverPanelContext";

function ye() {
  return _(X);
}

function Te(a, o) {
  return j(o.type, de, a, o);
}

var Ee = "div",
    Se = G(function (o, f) {
  var _j2;

  var e = "headlessui-popover-button-".concat($()),
      P = "headlessui-popover-panel-".concat($()),
      n = M(null),
      l = B(f, n),
      i = q(n),
      s = le(Te, {
    popoverState: 1,
    button: null,
    buttonId: e,
    panel: null,
    panelId: P
  }),
      _s = _slicedToArray(s, 2),
      _s$ = _s[0],
      v = _s$.popoverState,
      t = _s$.button,
      E = _s$.panel,
      u = _s[1];

  x(function () {
    return u({
      type: 3,
      buttonId: e
    });
  }, [e, u]), x(function () {
    return u({
      type: 5,
      panelId: P
    });
  }, [P, u]);
  var S = O(function () {
    return {
      buttonId: e,
      panelId: P,
      close: function close() {
        return u({
          type: 1
        });
      }
    };
  }, [e, P, u]),
      c = re(),
      d = c == null ? void 0 : c.registerPopover,
      p = m(function () {
    var r;
    return (r = c == null ? void 0 : c.isFocusWithinPopoverGroup()) != null ? r : (i == null ? void 0 : i.activeElement) && ((t == null ? void 0 : t.contains(i.activeElement)) || (E == null ? void 0 : E.contains(i.activeElement)));
  }, [c, t, E]);
  x(function () {
    return d == null ? void 0 : d(S);
  }, [d, S]), W(i == null ? void 0 : i.defaultView, "focus", function () {
    v === 0 && (p() || !t || !E || u({
      type: 1
    }));
  }, !0), fe([t, E], function (r, T) {
    v === 0 && (u({
      type: 1
    }), ae(T, ue.Loose) || (r.preventDefault(), t == null || t.focus()));
  });
  var y = m(function (r) {
    u({
      type: 1
    });

    var T = function () {
      return r ? r instanceof HTMLElement ? r : r.current instanceof HTMLElement ? r.current : t : t;
    }();

    T == null || T.focus();
  }, [u, t]),
      b = O(function () {
    return {
      close: y
    };
  }, [y]),
      g = O(function () {
    return {
      open: v === 0,
      close: y
    };
  }, [v, y]),
      C = o,
      h = {
    ref: l
  };
  return F.createElement(z.Provider, {
    value: s
  }, F.createElement(J.Provider, {
    value: b
  }, F.createElement(ie, {
    value: j(v, (_j2 = {}, _defineProperty(_j2, 0, U.Open), _defineProperty(_j2, 1, U.Closed), _j2))
  }, H({
    ourProps: h,
    theirProps: C,
    slot: g,
    defaultTag: Ee,
    name: "Popover"
  }))));
}),
    be = "button",
    me = G(function (o, f) {
  var _N = N("Popover.Button"),
      _N2 = _slicedToArray(_N, 2),
      e = _N2[0],
      P = _N2[1],
      n = M(null),
      l = re(),
      i = l == null ? void 0 : l.closeOthers,
      s = ye(),
      v = s === null ? !1 : s === e.panelId,
      t = B(n, f, v ? null : function (r) {
    return P({
      type: 2,
      button: r
    });
  }),
      E = B(n, f),
      u = q(n),
      S = M(null),
      c = M(null);

  W(u == null ? void 0 : u.defaultView, "focus", function () {
    c.current = S.current, S.current = u == null ? void 0 : u.activeElement;
  }, !0);
  var d = m(function (r) {
    var T, R, k, V;

    if (v) {
      if (e.popoverState === 1) return;

      switch (r.key) {
        case A.Space:
        case A.Enter:
          r.preventDefault(), (R = (T = r.target).click) == null || R.call(T), P({
            type: 1
          }), (k = e.button) == null || k.focus();
          break;
      }
    } else switch (r.key) {
      case A.Space:
      case A.Enter:
        r.preventDefault(), r.stopPropagation(), e.popoverState === 1 && (i == null || i(e.buttonId)), P({
          type: 0
        });
        break;

      case A.Escape:
        if (e.popoverState !== 0) return i == null ? void 0 : i(e.buttonId);
        if (!n.current || (u == null ? void 0 : u.activeElement) && !n.current.contains(u.activeElement)) return;
        r.preventDefault(), r.stopPropagation(), P({
          type: 1
        });
        break;

      case A.Tab:
        if (e.popoverState !== 0 || !e.panel || !e.button) return;

        if (r.shiftKey) {
          if (!c.current || (V = e.button) != null && V.contains(c.current) || e.panel.contains(c.current)) return;
          var Z = w(u == null ? void 0 : u.body),
              ne = Z.indexOf(c.current);
          if (Z.indexOf(e.button) > ne) return;
          r.preventDefault(), r.stopPropagation(), L(e.panel, I.Last);
        } else r.preventDefault(), r.stopPropagation(), L(e.panel, I.First);

        break;
    }
  }, [P, e.popoverState, e.buttonId, e.button, e.panel, n, i, v]),
      p = m(function (r) {
    var T;
    if (!v && (r.key === A.Space && r.preventDefault(), e.popoverState === 0 && !!e.panel && !!e.button)) switch (r.key) {
      case A.Tab:
        if (!c.current || (T = e.button) != null && T.contains(c.current) || e.panel.contains(c.current)) return;
        var R = w(u == null ? void 0 : u.body),
            k = R.indexOf(c.current);
        if (R.indexOf(e.button) > k) return;
        r.preventDefault(), r.stopPropagation(), L(e.panel, I.Last);
        break;
    }
  }, [e.popoverState, e.panel, e.button, v]),
      y = m(function (r) {
    var T, R;
    ee(r.currentTarget) || o.disabled || (v ? (P({
      type: 1
    }), (T = e.button) == null || T.focus()) : (r.preventDefault(), r.stopPropagation(), e.popoverState === 1 && (i == null || i(e.buttonId)), (R = e.button) == null || R.focus(), P({
      type: 0
    })));
  }, [P, e.button, e.popoverState, e.buttonId, o.disabled, i, v]),
      b = O(function () {
    return {
      open: e.popoverState === 0
    };
  }, [e]),
      g = se(o, n),
      C = o,
      h = v ? {
    ref: E,
    type: g,
    onKeyDown: d,
    onClick: y
  } : {
    ref: t,
    id: e.buttonId,
    type: g,
    "aria-expanded": o.disabled ? void 0 : e.popoverState === 0,
    "aria-controls": e.panel ? e.panelId : void 0,
    onKeyDown: d,
    onKeyUp: p,
    onClick: y
  };
  return H({
    ourProps: h,
    theirProps: C,
    slot: b,
    defaultTag: be,
    name: "Popover.Button"
  });
}),
    ge = "div",
    Ae = K.RenderStrategy | K.Static,
    Ce = G(function (o, f) {
  var _N3 = N("Popover.Overlay"),
      _N4 = _slicedToArray(_N3, 2),
      e = _N4[0].popoverState,
      P = _N4[1],
      n = B(f),
      l = "headlessui-popover-overlay-".concat($()),
      i = te(),
      s = function () {
    return i !== null ? i === U.Open : e === 0;
  }(),
      v = m(function (S) {
    if (ee(S.currentTarget)) return S.preventDefault();
    P({
      type: 1
    });
  }, [P]),
      t = O(function () {
    return {
      open: e === 0
    };
  }, [e]);

  return H({
    ourProps: {
      ref: n,
      id: l,
      "aria-hidden": !0,
      onClick: v
    },
    theirProps: o,
    slot: t,
    defaultTag: ge,
    features: Ae,
    visible: s,
    name: "Popover.Overlay"
  });
}),
    Re = "div",
    Oe = K.RenderStrategy | K.Static,
    Ie = G(function (o, f) {
  var _o$focus = o.focus,
      e = _o$focus === void 0 ? !1 : _o$focus,
      P = _objectWithoutProperties(o, _excluded),
      _N5 = N("Popover.Panel"),
      _N6 = _slicedToArray(_N5, 2),
      n = _N6[0],
      l = _N6[1],
      _oe = oe("Popover.Panel"),
      i = _oe.close,
      s = M(null),
      v = B(s, f, function (p) {
    l({
      type: 4,
      panel: p
    });
  }),
      t = q(s),
      E = te(),
      u = function () {
    return E !== null ? E === U.Open : n.popoverState === 0;
  }(),
      S = m(function (p) {
    var y;

    switch (p.key) {
      case A.Escape:
        if (n.popoverState !== 0 || !s.current || (t == null ? void 0 : t.activeElement) && !s.current.contains(t.activeElement)) return;
        p.preventDefault(), p.stopPropagation(), l({
          type: 1
        }), (y = n.button) == null || y.focus();
        break;
    }
  }, [n, s, l]);

  x(function () {
    return function () {
      return l({
        type: 4,
        panel: null
      });
    };
  }, [l]), x(function () {
    var p;
    o.static || n.popoverState === 1 && ((p = o.unmount) != null ? p : !0) && l({
      type: 4,
      panel: null
    });
  }, [n.popoverState, o.unmount, o.static, l]), x(function () {
    if (!e || n.popoverState !== 0 || !s.current) return;
    var p = t == null ? void 0 : t.activeElement;
    s.current.contains(p) || L(s.current, I.First);
  }, [e, s, n.popoverState]), W(t == null ? void 0 : t.defaultView, "keydown", function (p) {
    var b;
    if (n.popoverState !== 0 || !s.current || p.key !== A.Tab || !(t != null && t.activeElement) || !s.current || !s.current.contains(t.activeElement)) return;
    p.preventDefault();
    var y = L(s.current, p.shiftKey ? I.Previous : I.Next);
    if (y === Y.Underflow) return (b = n.button) == null ? void 0 : b.focus();

    if (y === Y.Overflow) {
      if (!n.button) return;
      var g = w(t.body),
          C = g.indexOf(n.button),
          h = g.splice(C + 1).filter(function (r) {
        var T;
        return !((T = s.current) != null && T.contains(r));
      });
      L(h, I.First) === Y.Error && L(t.body, I.First);
    }
  }), W(t == null ? void 0 : t.defaultView, "focus", function () {
    var p;
    !e || n.popoverState === 0 && (!s.current || (t == null ? void 0 : t.activeElement) && ((p = s.current) == null ? void 0 : p.contains(t.activeElement)) || l({
      type: 1
    }));
  }, !0);
  var c = O(function () {
    return {
      open: n.popoverState === 0,
      close: i
    };
  }, [n, i]),
      d = {
    ref: v,
    id: n.panelId,
    onKeyDown: S
  };
  return F.createElement(X.Provider, {
    value: n.panelId
  }, H({
    ourProps: d,
    theirProps: P,
    slot: c,
    defaultTag: Re,
    features: Oe,
    visible: u,
    name: "Popover.Panel"
  }));
}),
    Le = "div",
    xe = G(function (o, f) {
  var e = M(null),
      P = B(e, f),
      _pe = pe([]),
      _pe2 = _slicedToArray(_pe, 2),
      n = _pe2[0],
      l = _pe2[1],
      i = m(function (d) {
    l(function (p) {
      var y = p.indexOf(d);

      if (y !== -1) {
        var b = p.slice();
        return b.splice(y, 1), b;
      }

      return p;
    });
  }, [l]),
      s = m(function (d) {
    return l(function (p) {
      return [].concat(_toConsumableArray(p), [d]);
    }), function () {
      return i(d);
    };
  }, [l, i]),
      v = m(function () {
    var y;
    var d = Pe(e);
    if (!d) return !1;
    var p = d.activeElement;
    return (y = e.current) != null && y.contains(p) ? !0 : n.some(function (b) {
      var g, C;
      return ((g = d.getElementById(b.buttonId)) == null ? void 0 : g.contains(p)) || ((C = d.getElementById(b.panelId)) == null ? void 0 : C.contains(p));
    });
  }, [e, n]),
      t = m(function (d) {
    var _iterator = _createForOfIteratorHelper(n),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var p = _step.value;
        p.buttonId !== d && p.close();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, [n]),
      E = O(function () {
    return {
      registerPopover: s,
      unregisterPopover: i,
      isFocusWithinPopoverGroup: v,
      closeOthers: t
    };
  }, [s, i, v, t]),
      u = O(function () {
    return {};
  }, []),
      S = o,
      c = {
    ref: P
  };

  return F.createElement(Q.Provider, {
    value: E
  }, H({
    ourProps: c,
    theirProps: S,
    slot: u,
    defaultTag: Le,
    name: "Popover.Group"
  }));
}),
    tt = Object.assign(Se, {
  Button: me,
  Overlay: Ce,
  Panel: Ie,
  Group: xe
});
export { tt as Popover };